exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control {\n  font-family: \"FontAwesome\";\n  font-style: normal; }\n\n.addShop {\n  background-color: #b4181d;\n  color: #fff;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shops/shops.component.scss
// module id = ../../../../../src/app/shops/shops.component.scss
// module chunks = main